
import { FaRegFaceSmileBeam } from "react-icons/fa6";
import { FaRegFaceSmile } from "react-icons/fa6";
import { FaRegFaceMeh } from "react-icons/fa6";
import { FaRegFaceFrownOpen } from "react-icons/fa6";
import { FaRegFaceSurprise } from "react-icons/fa6";
import { FaRegFaceSadTear } from "react-icons/fa6";
import { FaRegFaceSadCry } from "react-icons/fa6";

import { FaBed, FaBiking } from "react-icons/fa";
import { MdAssistWalker, MdOutlineSportsMartialArts } from "react-icons/md";
import { FaPersonWalkingWithCane, FaPersonSwimming, FaPersonRunning } from "react-icons/fa6";
import { BsPersonWalking } from "react-icons/bs";
import { GiHiking, GiWeightLiftingUp, GiMountainClimbing } from "react-icons/gi";

export const helpers = {
    colors: [
        { value: '#e0e0e0', label: 'Light Gray' },
        { value: '#ffcdd2', label: 'Light Red' },
        { value: '#c8e6c9', label: 'Light Green' },
        { value: '#bbdefb', label: 'Light Blue' },
        { value: '#fff9c4', label: 'Light Yellow' },
        { value: '#e1bee7', label: 'Light Purple' },
        { value: 'white', label: 'White' },
        { value: '#ffe0b2', label: 'Light Orange' }
    ],
    timeFilterOptions: [
        { key: '7days', label: 'Last 7 Days', days: 7 },
        { key: '30days', label: 'Last 30 Days', days: 30 },
        { key: '90days', label: 'Last 90 Days', days: 90 },
        { key: '1year', label: 'Last Year', days: 365 },
        { key: 'all', label: 'All Time', days: null }
    ],

    sideAsString: (procedure) => {
        if (procedure.left && procedure.right) {
            return "Bilateral Hips"
        }
        if (procedure.left) {
            return "Left Hip"
        }
        return "Right Hip"
    },

    sideDisplay: (procedures) => {
        let side = helpers.sideAsString(procedures[0])
        procedures.forEach(procedure => {
            if (helpers.sideAsString(procedure) !== side) {
                return "Bilateral Hips"
            }
        })
        return side
    },
    procedureDisplay: (procedure) => {
        if (procedure.side == "bilateral") {
            return `Bilateral ${procedure.name}`;
        }
        return `${procedure.right ? 'Right ' : 'Left '} ${procedure.name}`
    },
    surgeryNameDisplay: (surgery) => {
        const d = new Date(surgery.surgeryDate);
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const yearShort = String(d.getFullYear()).slice(-2);
        return `${month}/${yearShort} ${helpers.sideDisplay(surgery.procedures)}`

    },
    getColorForScore: (score) => {
        if (score === 0) return '#94a3b8';
        if (score <= 2) return '#60a5fa';
        if (score <= 4) return '#3b82f6';
        if (score <= 6) return '#22c55e';
        if (score <= 8) return '#eab308';
        return '#ef4444';
    },
    getPainColorForScore: (score) => {
        if (score === 0) return '#10b981';
        if (score <= 3) return '#84cc16';
        if (score <= 6) return '#eab308';
        if (score <= 8) return '#f97316';
        return '#ef4444';
    },
    getPainIconForScore: (score) => {
        const painIcons = [
            FaRegFaceSmileBeam,
            FaRegFaceSmile,
            FaRegFaceMeh,
            FaRegFaceMeh,
            FaRegFaceSurprise,
            FaRegFaceSurprise,
            FaRegFaceFrownOpen,
            FaRegFaceFrownOpen,
            FaRegFaceSadTear,
            FaRegFaceSadCry,
            FaRegFaceSadCry,
        ];
        return painIcons[Math.round(score)]
    },
    getActivityIconForScore: (score) => {
        const activityIcons = [
            FaBed,
            MdAssistWalker,
            FaPersonWalkingWithCane,
            BsPersonWalking,
            FaBiking,
            FaPersonSwimming,
            GiHiking,
            FaPersonRunning,
            GiWeightLiftingUp,
            MdOutlineSportsMartialArts,
            GiMountainClimbing
        ];
        return activityIcons[Math.round(score)]
    },
    getDescriptionForScore: (score) => {
        if (score === 0) return 'No Activity';
        if (score <= 2) return 'Very Light Activity';
        if (score <= 4) return 'Light Activity';
        if (score <= 6) return 'Moderate Activity';
        if (score <= 8) return 'High Activity';
        return 'Very High Activity';
    },
    getPainDescriptionForScore: (score) => {
        if (score === 0) return 'No Pain';
        if (score <= 2) return 'Mild Pain';
        if (score <= 4) return 'Moderate Pain';
        if (score <= 6) return 'Moderate to Severe';
        if (score <= 8) return 'Severe Pain';
        return 'Worst Possible Pain';
    },
    englishDate: (isoString) => {
        const date = new Date(isoString);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleString('en-US', options);
    },
    formDataToReview: (formData) => {
        const [year, month, day] = formData.surgeryDate.split('-').map(Number)
        return {
            id: formData.id,
            procedures: formData.procedures,
            rating: formData.rating,
            description: formData.description,
            state: `${formData.state.id}`,
            surgeryMonth: parseInt(month, 10),
            surgeryYear: parseInt(year, 10),
            surgeryDay: parseInt(day, 10),
            npi: formData?.surgeon?.npi,
            public: formData.public
        };
    },
    reviewToFormData: (res) => {
        let actualProcedures = []
        let existingProcedures = {}
        res.procedures.forEach(procedure => {
            let side = "left"
            if (procedure.right) {
                side = "right"
            }
            if (!existingProcedures[procedure.id] && existingProcedures[procedure.id] !== 0) {
                existingProcedures[procedure.id] = actualProcedures.length
                actualProcedures.push({ ...procedure, side })
            } else {
                actualProcedures[existingProcedures[procedure.id]].side = "bilateral"
            }
        })
        const isoTimestamp = res.surgeryDate;
        const date = new Date(isoTimestamp);
        const formatted = date.toISOString().split('T')[0];
        const surgeon = res.surgeon.npi ? res.surgeon : null
        return { ...res, surgeryDate: formatted, procedures: actualProcedures, surgeon }
    },
    formatUpdatedAt: (date) => {
        const now = new Date();
        const utcNow = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(),
            now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());
        const utcDate = Date.UTC(new Date(date).getUTCFullYear(), new Date(date).getUTCMonth(),
            new Date(date).getUTCDate(), new Date(date).getUTCHours(),
            new Date(date).getUTCMinutes(), new Date(date).getUTCSeconds());
        const diffInSeconds = Math.round((utcNow - utcDate) / 1000);

        if (diffInSeconds < 60) {
            return `${diffInSeconds}s ago`;
        }

        const diffInMinutes = Math.round(diffInSeconds / 60);
        if (diffInMinutes < 60) {
            return `${diffInMinutes}m ago`;
        }

        const diffInHours = Math.round(diffInMinutes / 60);
        if (diffInHours < 24) {
            return `${diffInHours}h ago`;
        }

        const diffInDays = Math.round(diffInHours / 24);
        if (diffInDays < 7) {
            return `${diffInDays}d ago`
        }

        const diffInWeeks = Math.round(diffInDays / 7);
        if (diffInWeeks < 4) {
            return `${diffInWeeks} week${diffInWeeks !== 1 ? 's' : ''} ago`
        }

        const diffInMonths = Math.round(diffInDays / 30);
        if (diffInMonths < 12) {
            return `${diffInMonths} month${diffInMonths !== 1 ? 's' : ''} ago`
        }

        return new Date(date).toLocaleDateString();
    },

    formatTime: (date) => {
        const now = new Date();
        const utcNow = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(),
            now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());
        const utcDate = Date.UTC(new Date(date).getUTCFullYear(), new Date(date).getUTCMonth(),
            new Date(date).getUTCDate(), new Date(date).getUTCHours(),
            new Date(date).getUTCMinutes(), new Date(date).getUTCSeconds());
        const diffInSeconds = Math.floor((utcNow - utcDate) / 1000);

        if (diffInSeconds < 60) {
            return `${diffInSeconds}s`;
        }

        const diffInMinutes = Math.floor(diffInSeconds / 60);
        if (diffInMinutes < 60) {
            return `${diffInMinutes}m`;
        }

        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) {
            return `${diffInHours}h`;
        }

        const diffInDays = Math.floor(diffInHours / 24);
        if (diffInDays < 7) {
            return `${diffInDays}d`
        }

        return new Date(date).toLocaleDateString();
    },

    diaryTime: (date) => {
        const dateObj = new Date(date);
        return dateObj.toLocaleDateString() + ' at ' + dateObj.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    },

    postopTimestamp: (date) => {
        const surgeryDate = new Date(date);
        const now = new Date();
        const diffTime = Math.abs(now - surgeryDate);
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        const diffWeeks = Math.floor(diffDays / 7);
        const diffMonths = Math.floor(diffDays / 30);
        const diffYears = Math.floor(diffDays / 365);

        if (diffYears > 0) {
            return `${diffYears} Year${diffYears > 1 ? 's' : ''} Post-op`;
        } else if (diffMonths > 0) {
            return `${diffMonths} Month${diffMonths > 1 ? 's' : ''} Post-op`;
        } else if (diffWeeks > 0) {
            return `${diffWeeks} Week${diffWeeks > 1 ? 's' : ''} Post-op`;
        } else {
            return `${diffDays} Day${diffDays !== 1 ? 's' : ''} Post-op`;
        }
    },

    postopTimestampAt: (surgeryDateStr, postedDateStr) => {
        const surgeryDate = new Date(surgeryDateStr);
        const postedDate = new Date(postedDateStr);
        const diffTime = Math.abs(postedDate - surgeryDate);
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        const diffWeeks = Math.floor(diffDays / 7);
        const diffMonths = Math.floor(diffDays / 30);
        const diffYears = Math.floor(diffDays / 365);

        if (diffYears > 0) {
            return `${diffYears} Year${diffYears > 1 ? 's' : ''} Post-op`;
        } else if (diffMonths > 0) {
            return `${diffMonths} Month${diffMonths > 1 ? 's' : ''} Post-op`;
        } else if (diffWeeks > 0) {
            return `${diffWeeks} Week${diffWeeks > 1 ? 's' : ''} Post-op`;
        } else {
            return `${diffDays} Day${diffDays !== 1 ? 's' : ''} Post-op`;
        }
    },
}